module.exports = __webpack_public_path__ + "static/img/c-info-kerry.c517f0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/carriers/c-info-kerry.png
// module id = Vwq7
// module chunks = 31